import { render, staticRenderFns } from "./FeatureSelector.vue?vue&type=template&id=044fde4e&scoped=true&"
import script from "./FeatureSelector.vue?vue&type=script&lang=js&"
export * from "./FeatureSelector.vue?vue&type=script&lang=js&"
import style0 from "./FeatureSelector.vue?vue&type=style&index=0&id=044fde4e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "044fde4e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSlideXTransition } from 'vuetify/lib/components/transitions';
installComponents(component, {VSelect,VSlideXTransition})
